$ = require 'jquery'
{ maybeDisplayLimitsErrorOnCardAdd } = require 'app/scripts/views/card/card-limits-error'
PopOver = require 'app/scripts/views/lib/pop-over'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'

module.exports = class ListBulkMoveCardsView extends View
  viewTitleKey: 'move all cards in list'

  events:
    'click .js-select-list': 'selectList'

  render: ->
    data = @model.toJSON()
    data.lists = []

    lists = @model.getBoard().listList.models
    for list in lists
      _list = _.clone(list.toJSON())
      if _list.id == @model.id
        _list.current = true
      data.lists.push(_list)

    @$el.html(
      templates.fill(
        'list_bulk_card_move',
        data
      )
    )

    @

  selectList: (e) ->
    $targetList = $(e.target).closest('.js-select-list')
    targetListId = $targetList.attr("name")

    return if $targetList.hasClass('disabled')

    listDest = @modelCache.get('List', targetListId)
    # Copy the original list, since moving the cards will cause the list to
    # change
    cards = _.clone(@model.openCards().models)

    if cards.length > 0
      options = {
        $elem: $(e.target),
        destinationList: listDest,
      }
      if maybeDisplayLimitsErrorOnCardAdd(options)
        return

      track("Card", "Moved in Bulk via List Menu")
      for card in cards
        card.moveToList listDest, 1000

    PopOver.hide()

    return
